
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1920 1080"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"98.62","y1":"976.61","x2":"1822.65","y2":"976.61","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#e7b14f"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#f0dfa2"}})])]),_c('path',{attrs:{"fill":"url(#a)","d":"M98.62 926.65h1724.02v99.92H98.62z"}})])
          )
        }
      }
    